import React, { useEffect, useState, useCallback } from 'react';
import useApi from '../../api/useApi';
import '../../scrollbar.css';

function Table({ getTimeStreamData, showMap, height, deviceType }) {
  const user = localStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = JSON.parse(localStorage.user).organization.id;
  const [{ isLoading, isError, data }, getData] = useApi();
  const [stats, setStats] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const formModel = {
    asset_type: '',
    device_type: '',
    project_name: '',
    q: '',
  };
  const [formData, setFormData] = useState(formModel);
  const [selectedType, setSelectedType] = useState({ type: '' });
  const [state, projectData] = useApi();
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const handleDeviceTypeChange = useCallback((e) =>
    setFormData({
      ...formData,
      [e.target.name]: e.target.value === 'BLE Tag' ? 'BLE_TAG' : e.target.value === 'Cellular Tag' ? 'CATM1_TAG' : '',
    })
  );
  const [project, setProject] = useState([]);
  const day = 1000 * 60 * 60 * 24;
  const [currentPage, setcurrentPage] = useState(1);
  const [pageNummberLimit, setPageNumberLimit] = useState(5);
  const [maxPageNumberLimit, setmaxPageNumberLimit] = useState(5);
  const [minPageNumberLimit, setminPageNumberLimit] = useState(0);
  let itemsPerPage;
  if (window.screen.height <= 768) itemsPerPage = 10;
  else if (window.screen.height > 768 && window.screen.height <= 980) itemsPerPage = 12;
  else if (window.screen.height > 980 && window.screen.height <= 1080) itemsPerPage = 15;
  else if (window.screen.height > 1080 && window.screen.height <= 1440) itemsPerPage = 18;
  else if (window.screen.height > 1440 && window.screen.height <= 1800) itemsPerPage = 21;
  else if (window.screen.height > 1800 && window.screen.height <= 2160) itemsPerPage = 24;
  else if (window.screen.height > 2160) itemsPerPage = 27;
  const [pageCount, setpageCount] = useState(0);

  let pages = [];
  for (let i = 1; i <= Math.ceil(pageCount / itemsPerPage); i++) {
    pages.push(i);
  }
  const handleClick = (event) => {
    setcurrentPage(Number(event.target.id));
  };
  const renderPageNumbers = pages.map((number) => {
    if (number < maxPageNumberLimit + 1 && number > minPageNumberLimit) {
      return (
        <li key={number} id={number} onClick={handleClick} className={currentPage == number ? 'active' : null}>
          {number}
        </li>
      );
    }
    return null;
  });
  const renderPageNumbers1 = (number) => {
    return <li>{pages.length}</li>;
  };

  const handleNextbtn = (e) => {
    if (e.target.id === 'last') {
      setcurrentPage(pages.length);
      setmaxPageNumberLimit(maxPageNumberLimit + pageNummberLimit);
      setminPageNumberLimit(minPageNumberLimit + pageNummberLimit);
    } else {
      setcurrentPage(currentPage + 1);
      if (currentPage + 1 > maxPageNumberLimit) {
        setmaxPageNumberLimit(maxPageNumberLimit + pageNummberLimit);
        setminPageNumberLimit(minPageNumberLimit + pageNummberLimit);
      }
    }
  };

  const handlePreviousbtn = (e) => {
    if (e.target.id === 'first') {
      setcurrentPage(1);
      setmaxPageNumberLimit(maxPageNumberLimit - pageNummberLimit);
      setminPageNumberLimit(minPageNumberLimit - pageNummberLimit);
    } else {
      setcurrentPage(currentPage - 1);
      if ((currentPage - 1) % pageNummberLimit == 0) {
        setmaxPageNumberLimit(maxPageNumberLimit - pageNummberLimit);
        setminPageNumberLimit(minPageNumberLimit - pageNummberLimit);
      }
    }
  };
  let pageIncrementBtn = null;
  if (pages.length > maxPageNumberLimit) {
    pageIncrementBtn = <li onClick={handleNextbtn}>...</li>;
  }

  let pageDecrementBtn = null;
  if (pages.length > maxPageNumberLimit) {
    pageDecrementBtn = <li onClick={handlePreviousbtn}> ...</li>;
  }

  useEffect(() => {
    getData(`/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&page=${currentPage}`, 'GET');
    projectData(`/organization/${orgId}/projects`, 'GET');
  }, []);

  useEffect(() => {
    if (formData.device_type === '') {
      user && getData(`/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&page=${currentPage}`, 'GET');
    } else {
      user &&
        getData(
          `/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&type=${formData.device_type}&page=${currentPage}`,
          'GET'
        );
    }
  }, [currentPage]);

  useEffect(() => {
    if (selectedType !== formData.device_type) {
      user &&
        getData(
          `/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&type=${formData.device_type}&page=1`,
          'GET'
        );
      setcurrentPage(1);
    }
    setSelectedType({ type: formData.device_type });
    // getData(`/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&page=${currentPage}`, 'GET');
  }, [formData.device_type]);
  // useEffect(() => {
  //   getData(`/organization/${orgId}/assetRecentdata`, 'GET');
  //   projectData(`/organization/${orgId}/projects`, 'GET');
  // }, []);

  useEffect(() => {
    if (!state.isLoading && !state.isError && state.data) {
      setProject(state.data.projects);
    }
  }, [state.isLoading, state.isError, state.data]);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      if (data.recentData.length > 0) {
        data.recentData.map((item, idx) => {
          const ts = getTime(item?.recentData?.ts);
          item.latestTimeStamp = ts;
          return item;
        });
        const x = data.recentData.sort((a, b) => (a.latestTimeStamp < b.latestTimeStamp ? 1 : -1));
        setStats(x);
        if (currentPage === 1) {
          setpageCount(data.count);
        }
      }
    }
    if (isError) {
      setFilteredData([]);
      pages = [];
      setpageCount(0);
      setmaxPageNumberLimit(5);
      setminPageNumberLimit(0);
    }
  }, [isLoading, isError, data]);

  useEffect(() => {
    if (stats.length <= 0) {
      return;
    }
    if (formData.asset_type === '' && formData.device_type === '' && formData.project_name === '') {
      setFilteredData(stats);
    }
    let z = stats;

    if (formData.project_name) {
      z = z.filter((x) => x?.project?.projectName === formData.project_name);
    }

    if (formData.device_type) {
      z = z.filter((x) => x?.device?.deviceType === formData.device_type);
    }

    if (formData.asset_type) {
      z = z.filter((x) => x?.trackedUnit?.tuType === formData.asset_type);
    }
    // if (formData.q) {
    //   z = z.filter((x) => {
    //     const normalizedQuery = formData.q.toLowerCase();
    //     return (
    //       x?.device?.id?.toLowerCase().indexOf(normalizedQuery) >= 0 ||
    //       x?.trackedUnit?.trackingId?.toLowerCase().indexOf(normalizedQuery) >= 0
    //     );
    //   });
    // }

    if (z.length > 0) setFilteredData(z);
    else setFilteredData([]);
  }, [stats, formData.project_name, formData.asset_type]);

  const getDeviceId = (id) => {
    getTimeStreamData(id);
  };

  const getTime = (ts) => {
    let _date;
    if (ts > 9999999999) {
      _date = Number(ts);
      // _date = new Date(x);
    } else {
      _date = Number(ts * 1000);
      // _date = new Date();
    }

    return _date;
  };

  const getTimeoffset = (ts) => {
    // let _date;
    // if (ts > 9999999999) {
    //   _date = Number(ts);
    //   // _date = new Date(x);
    // } else {
    //   _date = Number(ts * 1000);
    //   // _date = new Date();
    // }

    // return _date;
    const _ts = Number(ts);
    const _date = new Date(_ts);
    const timeZoneOffset = _date.getTimezoneOffset();
    // const _timestamp = _date.getTime() - timeZoneOffset * 60 * 1000;
    const _timestamp = _date.getTime();
    if (Math.round((Date.now() - new Date(_timestamp).getTime()) / day) !== 0) {
      return `${Math.round((Date.now() - new Date(_timestamp).getTime()) / day)} days ago`;
    }

    if (parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5) !== 0) {
      return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 36e5)} hours ago`;
    }

    if (Math.round(((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000) !== 0) {
      return `${Math.round(
        ((Date.now() - (new Date(_timestamp).getTime() % 86400000)) % 3600000) / 60000
      )} minutes ago`;
    }

    return `${parseInt(Math.abs(Date.now() - new Date(_timestamp).getTime()) / 1000)} seconds ago`;

    Math.round(((diffMs % 86400000) % 3600000) / 60000);
  };

  const searchData = () => {
    getData(`/search?type=asset&searchItem=${formData.q}`, 'GET');
  };

  useEffect(() => {
    if (formData.q === '') {
      getData(`/organization/${orgId}/assetRecentdata?limit=${itemsPerPage}&page=1`, 'GET');
    }
  }, [formData.q]);

  return (
    <div >
      {/* </div>
    <div className="relative h-36" style={{ background: 'rgb(249, 249, 249' }}> */}
      <div className="z-50 " style={{ height: '22vh', paddingBottom: '4vh' }}>
        <div
          className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
          style={{ paddingTop: '4vh' }}
        >
          <span className="text-textBlue1 font-bold text-lg">Dashboard</span>
          <div className="block lg:flex mt-1 lg:mt-0">
            <div className="pagenumbers">
              <li>
                <button onClick={(e) => handlePreviousbtn(e)} disabled={currentPage == pages[0]}>
                  <img id="first" src="assets/img/arrowDoubleLeft.png" className="h-4 pt-1 pl-2" />
                </button>
              </li>
              <li>
                <button onClick={handlePreviousbtn} disabled={currentPage == pages[0]}>
                  <img className="button-rotate" src="assets/img/Arrows.svg" />
                </button>
              </li>

              {renderPageNumbers}
              {pageIncrementBtn}
              <li>
                <button onClick={handleNextbtn} disabled={currentPage == pages[pages.length - 1]}>
                  <img className="button-anti" src="assets/img/Arrows.svg" />
                </button>
              </li>
              <li>
                <button onClick={(e) => handleNextbtn(e)} disabled={currentPage == pages[pages.length - 1]}>
                  <img id="last" src="assets/img/arrowDoubleRight.png" className="h-4 pt-1" />
                </button>
              </li>
            </div>
            <div className="mt-1 lg:mt-0 w-full text-xs lg:w-max border bg-transparent px-3 rounded-sm ml-3 flex justify-between items-center rounded-xl">
              <input
                type="text"
                placeholder="Search"
                autoComplete="off"
                className="text-textBox bg-transparent focus:outline-none"
                value={formData.q}
                name="q"
                onChange={handleInputChange}
                style={{ borderColor: '#e6e6e6' }}
              />
              <img src="assets/img/Search.png" onClick={searchData} className="h-4 ml-2 " alt="" />
            </div>
          </div>
        </div>
      </div>
      <div className="tbl" style={{ minWidth: '700px' }}>
        <div className="bg-white w-tableWidth m-auto mb-3">
          <div className="bg-white w-full flex border" style={{ borderColor: '#e6e6e6' }}>
            <div className="px-8 py-2 flex w-full relative bg-primary text-white">
              <div className="w-1/2 py-1 text-xs font-bold">
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#ffffff"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                    style={{ borderColor: '#e6e6e6' }}
                    value={formData.asset_type}
                    name="asset_type"
                    onChange={handleInputChange}
                  >
                    <option value="">ASSET</option>
                    <option>BOX</option>
                    <option>PALLET</option>
                    <option>CONTAINER</option>
                    <option>UNIT</option>
                  </select>
                </div>
              </div>
              <div className="w-1/2 py-1 text-xs font-bold">
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#ffffff"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    value={
                      formData.device_type === 'BLE_TAG'
                        ? 'BLE Tag'
                        : formData.device_type === 'CATM1_TAG'
                          ? 'Cellular Tag'
                          : ''
                    }
                    name="device_type"
                    className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                    style={{ borderColor: '#e6e6e6' }}
                    onChange={handleDeviceTypeChange}
                  >
                    <option value="">DEVICE</option>
                    <option>BLE Tag</option>
                    <option>Cellular Tag</option>
                  </select>
                </div>
              </div>

              <div className="w-1/2 py-1 text-xs font-bold">
                <div className="relative inline-flex">
                  <svg
                    className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-3 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 412 232"
                  >
                    <path
                      d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                      fill="#ffffff"
                      fillRule="nonzero"
                    />
                  </svg>
                  <select
                    value={formData.project_name}
                    name="project_name"
                    className="border font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-8 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-md"
                    style={{ borderColor: '#e6e6e6' }}
                    onChange={handleInputChange}
                  >
                    <option value="">PROJECT</option>
                    {project.map((item) => (
                      <option key={item?.id}>{item?.projectName}</option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="w-1/2 py-2.5 text-xs text-left font-bold pl-2">SENSOR VALUES</div>
              <div className="w-1/4 py-2.5 text-xs font-bold">LAST REPORTED</div>
            </div>
          </div>
          {!isLoading ? (
            <div className="hideScroll" style={{ overflowY: 'scroll', height: height ? '20vh' : '64vh' }}>
              <div id="tblData" className="w-full">
                {filteredData.length !== 0 &&
                  filteredData.map((item, idx) => {
                    const modified = getTimeoffset(item?.latestTimeStamp);
                    let assetTypeIcon = item?.trackedUnit?.tuType !== null ? item?.trackedUnit?.tuType : '';
                    if (item?.trackedUnit?.tuType === 'BOX')
                      assetTypeIcon = <img src="./assets/img/Box.svg" className="w-5 h-5" />;
                    if (item?.trackedUnit?.tuType === 'UNIT')
                      assetTypeIcon = <img src="./assets/img/Unit.svg" className="w-5 h-5" />;
                    if (item?.trackedUnit?.tuType === 'CONTAINER')
                      assetTypeIcon = <img src="./assets/img/Container.svg" className="w-5 h-5" />;
                    if (item?.trackedUnit?.tuType === 'PALLET')
                      assetTypeIcon = <img src="./assets/img/Pallet.svg" className="w-5 h-5" />;
                    let deviceTypeIcon = item?.device?.deviceType !== null ? item?.device?.deviceType : '';
                    if (item?.device?.deviceType === 'BLE_TAG')
                      deviceTypeIcon = <img src="./assets/img/Bluetooth.svg" className="w-5 h-5" />;
                    if (item?.device?.deviceType === 'CATM1_TAG')
                      deviceTypeIcon = <img src="./assets/img/Cellular.svg" className="w-5 h-5" />;
                    if (item?.device?.deviceType === 'BLE_GW')
                      deviceTypeIcon = <img src="./assets/img/Gateway.svg" className="w-5 h-5" />;
                    const orgInfo = {
                      type: assetTypeIcon,
                      code: item?.trackedUnit?.trackingId,
                      deviceId: item?.device?.id,
                      deviceType: deviceTypeIcon,
                      projectName: item?.project?.projectName,
                      lastModified: modified,
                    };
                    return (
                      <div
                        tabIndex={idx}
                        id={idx}
                        className="my-1 px-8 flex
                      relative focus:bg-rowSelect hover:bg-rowSelect"
                        style={{ border: '0.5px solid #C0C0C0', boxSizing: 'border-box', borderRadius: '4px' }}
                      >
                        <div
                          className="w-1/2 flex items-center text-role py-1 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                          onClick={(e) => {
                            getDeviceId(item?.device?.id);
                            showMap(true);
                            deviceType(item?.trackedUnit?.trackingId, orgInfo.deviceId);
                            setTimeout(() => {
                              document.getElementById(idx).scrollIntoView({ behavior: 'smooth' });
                            }, 200);
                          }}
                        >
                          {orgInfo.type}
                          <a
                            href="#"
                            className="py-2 ml-2 text-xs md:no-underline md:hover:underline"
                            style={{ color: 'blue' }}
                          >
                            {orgInfo.code}
                          </a>
                        </div>

                        <div
                          className="w-1/2 flex items-center text-role py-1 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                          onClick={() => {
                            showMap(false);
                          }}
                        >
                          {orgInfo.deviceType}
                          <span className="ml-2">{orgInfo.deviceId}</span>
                        </div>

                        <div
                          className="w-1/2 flex text-role items-center py-1 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                          onClick={() => {
                            showMap(false);
                          }}
                        >
                          {orgInfo.projectName}
                        </div>
                        <div
                          className="flex w-1/2 items-center text-role py-1 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                          onClick={() => {
                            showMap(false);
                          }}
                        >
                          {item?.recentData?.tm ? (
                            <div className="flex items-center mr-2">
                              <img src="assets/img/temperature.png" className="w-2 mx-2 mt-1" alt="" />
                              {parseFloat(item?.recentData?.tm).toFixed(1)}
                            </div>
                          ) : null}
                          {item?.recentData?.h ? (
                            <div className="flex items-center mr-2">
                              <img src="assets/img/humidity.png" className="w-3 mx-2 mt-1" alt="" />
                              {parseFloat(item?.recentData?.h).toFixed(1)}
                            </div>
                          ) : null}
                          {item?.recentData?.prs ? (
                            <div className="flex items-center">
                              <img src="assets/img/pressure.png" className="w-3 mx-2 mt-1" alt="" />
                              {parseFloat(item?.recentData?.prs).toFixed(1)}
                            </div>
                          ) : null}
                        </div>
                        <div
                          className="w-1/4 flex text-role items-center py-1 text-left overflow-ellipsis overflow-hidden whitespace-nowrap text-xs"
                          onClick={() => {
                            showMap(false);
                          }}
                        >
                          {orgInfo.lastModified}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          ) : (
            <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
          )}
        </div>
      </div>
    </div>
  );
}

export default Table;
